module.exports = __webpack_public_path__ + "static/media/gal-7.385fc695.jpeg";